
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 31"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.763 16.094H10.93v2.737","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.56 16.629a4.089 4.089 0 01-1.655 2.07 4.326 4.326 0 01-2.618.67 4.292 4.292 0 01-2.5-1.007 4.037 4.037 0 01-1.347-2.268M17.165 13.904H20v-2.737","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.37 13.368a4.09 4.09 0 011.654-2.069 4.328 4.328 0 012.618-.669 4.291 4.291 0 012.498 1.007 4.037 4.037 0 011.348 2.267M10.714 27l-2.5 3h14.5l-2.5-3","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"6.75","y":"3.75","width":"17.5","height":"21.5","rx":"7.25","stroke":"currentColor","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13 1.5h5","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    